import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { space } from '@elementary/common-ui/style/utils';
import BarStack from '../BarStack';

const Wrapper = styled(Flex)`
  align-items: center;
  gap: ${space('sm')};
  width: 52px;
  justify-content: space-between;
`;

const coverageRenderer = (value: number) => (
  <Wrapper>
    <Typography>{`${value}%`}</Typography>
    <BarStack value={value} />
  </Wrapper>
);

export default coverageRenderer;
